import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={onClose} data-id="element-28">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-29" />
      <div className="relative bg-navy-800 border border-steel-400/10 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-30">
        <div className="flex items-center justify-between p-6 border-b border-steel-400/10" data-id="element-31">
          <h2 className="text-xl font-semibold text-steel-100" data-id="element-32">{title}</h2>
          <button onClick={onClose} className="p-2 rounded-lg text-steel-400 hover:text-steel-200 hover:bg-steel-400/10 transition-colors" aria-label="Cerrar" data-id="element-33">
            <XIcon className="w-5 h-5" data-id="element-34" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-steel-300 text-sm leading-relaxed space-y-4" data-id="element-35">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 text-center text-steel-500 text-sm border-t border-steel-400/5" data-id="element-36">
        <p className="mb-3" data-id="element-37">
          © {new Date().getFullYear()} Memoria de Acero. Todos los derechos
          reservados.
        </p>
        <div className="flex items-center justify-center gap-4" data-id="element-38">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-amber-400 transition-colors underline underline-offset-2" data-id="element-39">
            Política de Privacidad
          </button>
          <span data-id="element-40">•</span>
          <button onClick={() => setActiveModal('terms')} className="hover:text-amber-400 transition-colors underline underline-offset-2" data-id="element-41">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-42">
        <p data-id="element-43">
          <strong data-id="element-44">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-45">
          En Memoria de Acero, nos comprometemos a proteger tu privacidad. Esta
          política describe cómo recopilamos, usamos y protegemos tu información
          personal.
        </p>
        <h3 className="text-steel-100 font-semibold mt-4" data-id="element-46">
          1. Información que recopilamos
        </h3>
        <p data-id="element-47">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y darte acceso al producto: nombre, correo electrónico y datos
          de pago. No almacenamos datos de tarjetas de crédito directamente;
          estos son procesados por proveedores de pago seguros.
        </p>
        <h3 className="text-steel-100 font-semibold mt-4" data-id="element-48">
          2. Uso de la información
        </h3>
        <p data-id="element-49">
          Tu información se utiliza exclusivamente para: procesar tu pedido,
          darte acceso al contenido adquirido y enviarte comunicaciones
          relacionadas con tu compra. No vendemos ni compartimos tu información
          con terceros para fines de marketing.
        </p>
        <h3 className="text-steel-100 font-semibold mt-4" data-id="element-50">
          3. Protección de datos
        </h3>
        <p data-id="element-51">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal contra acceso no autorizado,
          alteración o destrucción.
        </p>
        <h3 className="text-steel-100 font-semibold mt-4" data-id="element-52">4. Tus derechos</h3>
        <p data-id="element-53">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. También puedes solicitar la
          portabilidad de tus datos o retirar tu consentimiento para el
          procesamiento de los mismos.
        </p>
        <h3 className="text-steel-100 font-semibold mt-4" data-id="element-54">5. Cookies</h3>
        <p data-id="element-55">
          Utilizamos cookies esenciales para el funcionamiento del sitio y
          cookies analíticas para mejorar tu experiencia. Puedes gestionar tus
          preferencias de cookies en la configuración de tu navegador.
        </p>
      </Modal>

      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-56">
        <p data-id="element-57">
          <strong data-id="element-58">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-59">
          Al acceder y utilizar este sitio web y adquirir nuestros productos,
          aceptas los siguientes términos y condiciones.
        </p>
        <h3 className="text-steel-100 font-semibold mt-4" data-id="element-60">
          1. Producto digital
        </h3>
        <p data-id="element-61">
          "Memoria de Acero: El Protocolo de Noche" es un producto digital de
          contenido informativo y educativo. Los resultados pueden variar según
          cada persona. Este producto no sustituye el consejo médico
          profesional.
        </p>
        <h3 className="text-steel-100 font-semibold mt-4" data-id="element-62">
          2. Acceso y licencia
        </h3>
        <p data-id="element-63">
          Al completar tu compra, recibirás acceso de por vida al contenido del
          producto. La licencia es personal e intransferible. Queda prohibida la
          reproducción, distribución o reventa del contenido.
        </p>
        <h3 className="text-steel-100 font-semibold mt-4" data-id="element-64">3. Pagos</h3>
        <p data-id="element-65">
          Todos los pagos se procesan de forma segura a través de proveedores de
          pago certificados. El precio mostrado al momento de la compra es el
          precio final. No hay cargos ocultos ni suscripciones recurrentes.
        </p>
        <h3 className="text-steel-100 font-semibold mt-4" data-id="element-66">
          4. Política de reembolso
        </h3>
        <p data-id="element-67">
          Dado que se trata de un producto digital con acceso inmediato, no se
          ofrecen reembolsos una vez que se ha accedido al contenido. Si tienes
          problemas técnicos para acceder al producto, haremos todo lo posible
          por resolverlos.
        </p>
        <h3 className="text-steel-100 font-semibold mt-4" data-id="element-68">
          5. Limitación de responsabilidad
        </h3>
        <p data-id="element-69">
          El contenido se proporciona "tal cual" con fines informativos. No
          garantizamos resultados específicos. No nos hacemos responsables de
          decisiones tomadas basándose en el contenido del producto.
        </p>
        <h3 className="text-steel-100 font-semibold mt-4" data-id="element-70">6. Modificaciones</h3>
        <p data-id="element-71">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          este sitio.
        </p>
      </Modal>
    </>;
}